import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://seqsffaiwzudccqsjqqx.supabase.co';
const supabaseAnonKey = 'sb_publishable_YUYs31mvmy5rlgJYXCJtzQ_RfA0VjTH';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  }
});
